




















































import {
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import NormalizerMixin from '@/mixins/NormalizerMixin';
import RepeatableInputGroup from '@/components/common/RepeatableInputGroup.vue';
import { cloneDeep } from 'lodash';

@Component({
  components: {
    RepeatableInputGroup,
  },
  inheritAttrs: false,
})
export default class WorkReadCollection extends Mixins(NormalizerMixin) {
  @Prop({
    type: Array,
    default: () => [],
  }) readonly collection!: Array<any>

  @Prop({
    type: Array,
    default: () => [],
  }) readonly initialCollection!: Array<any>

  @Prop({
    type: Boolean,
    default: false,
  }) readonly editableQuantity!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly limitMaxQuantity!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly editableSize!: boolean

  @Prop({
    type: String,
    default: '',
  }) readonly icon!: string

  @Prop({
    type: String,
    default: '',
  }) readonly title!: string

  @Prop({
    type: Array,
    default: () => [],
  }) readonly workHeaders!: any

  normalizedWorkData: Array<any> = [];

  beforeMount() {
    this.normalizedWorkData = this.normalizeWorkData();
  }

  getInitialItem(item: any) {
    const index = this.normalizedWorkData.findIndex((v: any) => v === item);
    return this.initialCollection[index] || {};
  }

  normalizeWorkData() {
    if (!this?.collection?.length) {
      return [];
    }
    const normalized = this.collection.map((v) => {
      const norm = { ...v };
      const keys = Object.keys(v);
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        norm[key] = this.$t(this.normalizeValue(v[key]));
      }
      return norm;
    });
    return normalized;
  }

  dataChange(item: any, valueName: string, value: any, maxValue: number | undefined | null) {
    if (maxValue !== null && Number(maxValue) && Number(value) > Number(maxValue)) {
      this.$bus.$emit('notification', 'Количество не может быть больше заявленной', 'warning');
      return null;
    }
    const normalizedCollection = this.normalizedWorkData;
    const collection = this.collection;
    for (let i = 0; i < normalizedCollection.length; i += 1) {
      const currentNormalizedItem = normalizedCollection[i];
      const currentItem = collection[i];
      const clonedItem = cloneDeep(currentItem);
      if (currentNormalizedItem === item && currentNormalizedItem[valueName] !== undefined) {
        clonedItem[valueName] = value;
      }
      collection[i] = clonedItem;
    }
    this.$emit('change', collection);
    return null;
  }
}
